module.exports = __webpack_public_path__ + "img/aermod-run-info.97fe6302.png";